import React, { Component } from 'react';
import { Breadcrumb, Col, Row } from "reactstrap";

class UsefulLinks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            file:null
        };
    }

    render() {
        return (
            <div>
                <Row className='subheader'>
                    <Col className='col-8'>
                        <h1>Useful Links</h1>
                    </Col>
                    <Col className='col-4'>
                        <Breadcrumb>
                        </Breadcrumb>
                    </Col>
                </Row>
                <div  className='page-cnt'>
                <Row>
                    <Col>
                        <p>
                            <a href={'https://dyce-energy.co.uk/faqs/'} target={'_blank'}>FAQ's</a>
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                        <a href={'https://dyce-energy.co.uk/downloads/'} target={'_blank'}>Downloads</a>
                        </p>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p>
                        <a href={'https://dyce-energy.co.uk/news/'} target={'_blank'}>News</a>
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                        <a href={'https://dyce-energy.co.uk/contact/'} target={'_blank'}>Contact Us</a>
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                        <a href={(window.config.consul.TERMS_AND_CONDITIONS_URL || (typeof TERMS_AND_CONDITIONS_URL !== 'undefined' ? TERMS_AND_CONDITIONS_URL : '' ))} target={'_blank'}>Terms &amp; Conditions</a>
                        </p>
                    </Col>
                </Row>
                </div>
            </div>
        )
    }
}

export default UsefulLinks;
